var initResendLink = function() {
  var $link = $('#js-confirmation-notification-link');
  $link.click(function(e){
    $.ajax({
      url: Kadenze.Routes.user_confirmation_path({user: {email: $link.data('email')}}),
      method: 'post',
      success: function(data) {}
    });
    $link.parents('#js-confirmation-notification').slideUp(1000);
    e.preventDefault();
  });
};

export default {
  init: function() {
    initResendLink();
  }
};
